export default __webpack_public_path__ + "static/hello-people-9f439020120a27b09fcf182eab55ec11.jpg";